import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Helmet } from 'react-helmet';
import { CancelRounded } from '@mui/icons-material';
import myFunctions from '../myFunctions';

const PopUpCardComIframe = (props) => {


    const [open, setOpen] = useState(true);
    const [err, setErr] = useState((props.errorMsg == "") ? false : true);

    const handleClose = () => {
         if (typeof props.cancelClick === 'function') props.cancelClick();
    };

    myFunctions.useEscapeKey(props.hideCloseBtn ? () => {} : handleClose);





    return (
        <>
            <Dialog open={open} className={`iframeBlock popDiagBlock ${props.cssStyl ? props.cssStyl : ""}`}>
                <DialogContent className={`iframeBlockDialogContent`}>
                    {/* <DialogContentText> */}

                    {/* {console.log(props.theData)} */}
                    {/* {window.gamapayInit(props.theData.session)} */}
                    {!props.hideCloseBtn &&
                        <button type="button" className={`btnReset iframeCloseBtn`} aria-label="סגור" onClick={() => handleClose()}>
                            <CancelRounded className={"popUpCloseBtn pointing"} aria-hidden="true" />
                        </button>
                    }
                    <iframe src={props.theData} className={"iframeBlockIframe"}/>

                    {/* {props.ContentText.map((txtItm, index) => {
                            return (
                                <span key={index}>{txtItm}<br /></span>
                            )
                        })} */}
                    {/* </DialogContentText> */}
                </DialogContent>
                {/*
                  כאן היה בעבר כפתור "אשלם במזומן" שהחליף את ההזמנה לתשלום מזומן
                  מתוך חלון קארדקום. הוא הוסר בכוונה ואין להחזירו:
                  מעבר למזומן חייב לעבור דרך מסך ההזמנה, כדי שסטטוס התשלום
                  והקרדיטים יתעדכנו נכון. ראה crditProblem ב-TheOrderList.
                */}
            </Dialog>
        </>
    );

}

export default PopUpCardComIframe;